import { GetStaticProps } from 'next';

import savvasFrontpageImage from '../../assets/images/bluebonetfontpage.png';
import SavvasMyViewLandingContent from '../../components/_organisms/SavvasMyViewLandingContent';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import { DefaultLocale } from '../../providers/tolgee';

const SavvasMyViewLandingPage = () => {
  return (
    <LandingPageLayout
      title="The Curipod + Savvas myView & myPerspectives Texas"
      ogTitle="Savvas myView & myPerspectives Texas is your curriculum. Curipod brings engagement, writing, and insights."
      subTitle="Research-based writing practice including SCRs, ECRs, Revision & editing and more."
      image={savvasFrontpageImage}
      disableHeadline={true}
    >
      <SavvasMyViewLandingContent />
    </LandingPageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      _tolgeeSSR: {
        language: DefaultLocale,
      },
    },
  };
};

export default SavvasMyViewLandingPage;
